/**
 * @class ServerResultWinline
 * @constructor
 * @returns {ServerResultWinline}
 */
export default function ServerResultWinline() {
    /** @type {Object} */
    this._winline;
};

/**
 * @param {Object} winline
 */
ServerResultWinline.prototype.init = function(winline) {
    this._winline = winline;
};

ServerResultWinline.prototype.getWin = function() {
    return this._winline["win"];
};

ServerResultWinline.prototype.getMultiplier = function() {
    return this._winline["multiplier"];
};

ServerResultWinline.prototype.getPosition = function() {
    return this._winline["position"];
};

ServerResultWinline.prototype.getSymbol = function() {
    return this._winline["symbol"];
};

ServerResultWinline.prototype.getType = function() {
    return this._winline["type"];
};

ServerResultWinline.prototype.getLine = function() {
    return this._winline["line"];
};